import { jsx as _jsx } from "react/jsx-runtime";
import Button from '@jetbrains/ring-ui/components/button/button';
import add from '@jetbrains/icons/add';
export function AddSettingButton({ active, glyph, ...props }) {
    return _jsx(Button, { icon: glyph || add, short: true, active: active, ...props });
}
